
// 
export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


export const metaInfo= {
  title: '为园区/企业构建“可防可控”的安全生产、能源能耗管理综合体系，实现一体化智慧监管解决方案',
  meta: [
    {
      name: 'keywords',
      content: '为园区/企业构建“可防可控”的安全生产、能源能耗管理综合体系，实现一体化智慧监管解决方案'
    },
    {
      name: 'description',
      content: '为园区/企业构建“可防可控”的安全生产、能源能耗管理综合体系，实现一体化智慧监管解决方案'
    }
  ]
}




// WEBPACK FOOTER //
// ./src/utils/index.js